import { render, staticRenderFns } from "./module-template.vue?vue&type=template&id=56e01f7c&scoped=true&"
import script from "./module-template.vue?vue&type=script&lang=js&"
export * from "./module-template.vue?vue&type=script&lang=js&"
import style0 from "./module-template.vue?vue&type=style&index=0&id=56e01f7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e01f7c",
  null
  
)

export default component.exports